import { ConfigProvider, Switch, SwitchProps, theme } from 'antd';
import { FC, memo } from 'react';

type Props = SwitchProps & object;

export const SwitchSuccess: FC<Props> = memo((props) => {
  const { token } = theme.useToken();

  return (
    <ConfigProvider theme={{ token: { colorPrimary: token['green-6'] } }}>
      <Switch { ...props }/>
    </ConfigProvider>
  );
});
